export default {
  sihuaLu: '禄',
  sihuaQuan: '権',
  sihuaKe: '科',
  sihuaJi: '忌',
} as const;
